import React from "react";

export default function Menu() {
  return (
    <div className="menuContainer primary white">
      <div className="menuExchange">MARGIN TOTAL</div>
      <div className="menuExchange">MARGIN CURRENT</div>
      <div className="menuExchange">CASH DEPOSIT</div>
      <div className="menuExchange">MARGIN USE</div>
      <div className="menuExchange">MARGIN DIFF</div>
      <div className="menuExchange">INTEREST RATE</div>
      <div className="menuExchange">DATE</div>
    </div>
  );
}
